import { RouteRecordRaw } from 'vue-router'

import { BETA_FEATURE_ROUTE_NAMES } from '@/modules/betaFeatures/constants/BetaFeaturesRouteNames'

import { UserGroup } from '@generated/types'

export const betaFeatureRoutes: RouteRecordRaw[] = [
  {
    path: '/venue/beta-features',
    name: BETA_FEATURE_ROUTE_NAMES.LIST,
    component: () => import('@/modules/betaFeatures/pages/BetaFeaturesList.vue'),
    meta: {
      requiresAuth: UserGroup.OWNERS,
      pageTitle: 'Beta Features',
    },
  },
]
